<template>
  <v-app>
    <v-app-bar app flat>
      <FullHeaderComponent />
    </v-app-bar>
    <v-main class="home">
      <div v-if="$store.state.maintenance_mode" class="yellow accent-3">
        <div class="container1400 pa-10">
          <h2 class="text-h4 font-weight-medium text-center">
            {{ $t("s1648244679") }}
          </h2>
          <p class="pt-5 body-1 text-center">
            {{ $t("s1648244698") }}
            <br /><br />
            <v-btn
              href="https://member.nomadrooms.com/contact-us/"
              target="_blank"
              large
              elevation="0"
              color="white"
              >{{ $t("s1648245914") }}</v-btn
            >
          </p>
        </div>
      </div>
      <div class="home-sec-1 py-16">
        <div class="container1400">
          <v-row align="center">
            <v-col md="6" cols="12">
              <h2 class="text-h4 pl-5 pb-6 font-weight-medium">
                <span class="light-blue--text">{{ $t("Nomad") }}</span
                ><br />{{ $t("WelcomeMsg") }}
              </h2>
              <v-form
                id="home-search-form"
                ref="form"
                class="pl-5 pr-5"
                style="max-width: 800px"
                @submit.prevent="submit"
              >
                <v-row no-gutters>
                  <v-col cols="12" md="9">
                    <v-autocomplete
                      solo
                      no-filter
                      hide-details="auto"
                      v-model="location"
                      :loading="loading"
                      :rules="reqRules"
                      :items="entries"
                      :search-input.sync="search"
                      item-text="locale_names"
                      disable-lookup
                      v-bind:placeholder="$t('TypeYourDestination')"
                      return-object
                      height="70px"
                      hide-no-data
                    >
                      <template v-slot:item="data">
                        <v-list-item-avatar>
                          <v-icon color="light-blue"
                            >mdi-map-marker-radius</v-icon
                          >
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="data.item.locale_names"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </template>
                      <template v-slot:append-item>
                        <v-divider class="mb-2"></v-divider>
                        <v-list-item
                          v-for="pro in properties"
                          :key="pro._id"
                          :to="{
                            name: 'GuestViewListing',
                            params: { id: pro._id }
                          }"
                        >
                          <v-list-item-avatar
                            v-for="(pic, i) in pro.pictures"
                            :key="i"
                          >
                            <v-img
                              :alt="`${pro.name} avatar`"
                              :src="
                                $store.state.baseUrl +
                                  'listing/thumb320x240-' +
                                  pic.file_name
                              "
                            ></v-img>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ pro.name }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ pro.location }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-btn
                      block
                      depressed
                      x-large
                      height="70px"
                      class="light-blue white--text homeSearch"
                      @click="submit"
                    >
                      <v-icon>mdi-magnify</v-icon>
                      <span class="ml-2">{{ $t("Search") }}</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
            <v-col md="6" cols="12">
              <v-img
                src="../assets/images/homebg.png"
                alt="Nomad Rooms"
                class="shrink mr-2"
                contain
                transition="scale-transition"
                max-width="80%"
              />
            </v-col>
          </v-row>
        </div>
      </div>
      <div class="blue-grey lighten-5 py-16">
        <v-container class="section-2 container1400 pb-16">
          <v-row class="align-center">
            <v-col md="6" cols="12">
              <v-img
                src="../assets/images/member.png"
                alt="Nomad Rooms"
                class="shrink mr-2"
                contain
                transition="scale-transition"
                max-width="100%"
              />
            </v-col>
            <v-col md="6" cols="12">
              <h2 class="text-h4 pb-6 font-weight-medium">
                {{ $t("HM1") }}
              </h2>
              <p class="body-1">{{ $t("HMP1") }}</p>
              <p class="body-1">{{ $t("HMP2") }}</p>
              <p class="body-1">
                {{ $t("string716") }}
                <v-btn
                  class="d-none d-md-inline-flex pa-0"
                  color="light-blue"
                  text
                  href="https://member.nomadrooms.com/for-members/"
                  target="_blank"
                >
                  {{ $t("string717") }}
                </v-btn>
              </p>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div class="grey lighten-4 py-16">
        <v-container class="section-2 container1400 pb-16">
          <v-row class="align-center">
            <v-col md="6" cols="12">
              <h2 class="text-h4 pb-6 font-weight-medium">
                {{ $t("HM2") }}
              </h2>
              <p class="body-1">{{ $t("HMP21") }}</p>
              <p class="body-1">
                {{ $t("string716") }}
                <v-btn
                  class="d-none d-md-inline-flex pa-0"
                  color="light-blue"
                  text
                  href="https://member.nomadrooms.com/for-partners/"
                  target="_blank"
                >
                  {{ $t("string718") }}
                </v-btn>
              </p>
            </v-col>
            <v-col md="6" cols="12">
              <v-img
                src="../assets/images/partner.png"
                alt="Nomad Rooms"
                class="shrink mr-2"
                contain
                transition="scale-transition"
                max-width="100%"
              />
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-main>
    <v-footer app>
      <CopyrightComponent />
    </v-footer>
  </v-app>
</template>

<script>
// @ is an alias to /src
import modeMixin from "@/mixins/modeMixin.js";
import FullHeaderComponent from "@/components/layout/FullHeaderComponent.vue";
import CopyrightComponent from "@/components/layout/CopyrightComponent.vue";
import ListingService from "@/services/ListingService";

export default {
  name: "Home",
  components: {
    FullHeaderComponent,
    CopyrightComponent
  },
  mixins: [modeMixin],
  data() {
    return {
      items: [],
      list: [],
      search: null,
      loading: false,
      location: null,
      reqRules: [value => !!value || this.$t("string719")]
    };
  },
  watch: {
    search(val) {
      val && val.length > 3 && val !== this.select && this.citySelections(val);
    }
  },
  computed: {
    entries() {
      return this.items.map(e => {
        const locale_names = e.place_name;
        const lat = e.center[1];
        const lng = e.center[0];
        return Object.assign({}, { locale_names, lat, lng });
      });
    },
    properties() {
      return this.list.map(e => {
        if (e._id) {
          return e;
        }
      });
    }
  },
  methods: {
    async citySelections(val) {
      if (val) {
        await ListingService.citySearch({
          query: val
        })
          .then(result => {
            this.items = result.data.features;
          })
          .catch(err => {
            this.error = err.response.data.errors;
          });
        await ListingService.searchLocation({ text: val })
          .then(result => {
            this.list = result.data.list;
          })
          .catch(err => {
            this.error = err.response.data.errors;
          });
      }
    },
    async submit() {
      await this.$refs.form.validate();
      if (this.location) {
        // Google Tag Manager
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "homePageSearch",
          searchLocation: this.location.locale_names
        });
        // Google Tag Manager
        this.$store.dispatch("setSearchQuery", this.location);
        this.$router.push({ name: "SearchListing" });
      }
    }
  }
};
</script>
<style>
.home-sec-1 {
  background-image: url("../assets/images/sec1bg1.png");
  background-repeat: repeat-x;
  background-size: contain;
  position: relative;
}
.home-sec-1::after {
  content: "";
  background-color: #abc5d2;
  display: block;
  width: 100%;
  height: 200px;
  position: absolute;
  bottom: 0;
  left: 0;
}
.home-sec-1 .container1400 {
  background-image: url("../assets/images/plane.png");
  background-size: 30%;
  position: relative;
  z-index: 1;
  background-position: -45% 90%;
  animation: animatedBackground 20s linear infinite;
}

@keyframes animatedBackground {
  0% {
    background-position: -45% 90%;
  }
  100% {
    background-position: 90% -35%;
  }
}
</style>
